/* eslint-disable react/react-in-jsx-scope */

'use client'

import { useState, useEffect } from 'react';
import { useCarts, useCartsDispatch } from '../contexts/CartContext';
import { Link } from "react-router"
import { useNavigate } from "react-router";
import { useUserContext } from '../contexts/UserContext';
import axios from 'axios';

// function currencyFormat(num) {
//   return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '1,') + '฿'
// }

function numberWithCommas (nStr) {
  nStr = nStr.toFixed(2) + '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    x = x1 + x2;
    if(x.substr(0,1) === '.'){
        x = '0' + x;
    }
    return x + '฿';
};


function formatDateTime() {
  const now = new Date();

  const year = now.getFullYear(); // Get the year
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed, so add 1
  const day = String(now.getDate()).padStart(2, '0'); // Day of the month

  const hours = String(now.getHours()).padStart(2, '0'); // Hours
  const minutes = String(now.getMinutes()).padStart(2, '0'); // Minutes
  const seconds = String(now.getSeconds()).padStart(2, '0'); // Seconds

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

// function getDate() {
//   const now = new Date();

//   // Extract the date components
//   const datePart = now.toLocaleDateString('en-GB'); // Gives dd/mm/yyyy format directly in 'en-GB' locale

//   // Extract the time components
//   const timePart = now.toTimeString().split(' ')[0]; // Split by space and take the first part (hh:mm:ss)

//   return `${datePart} ${timePart}`;
// }

const apiurl = `${process.env.REACT_APP_API}`


export default function CheckOut() {
  const cart = useCarts();
  const dispatch = useCartsDispatch();

  const user = useUserContext();

  const navigate = useNavigate();
  const [saveStatus, setSaveStatus] = useState(false);
  const [saving, setSaving] = useState(false);
  const [paid, setPaid] = useState();
  const [input, setInput] = useState({
     paidtype: "",
     discount1: 0,
     discount2: 0,
     vat: 0,
  });
  const [discount1, setDiscount1] = useState(0);
  const [discount2, setDiscount2] = useState(0);
  const [paidcash, setPaidcash] = useState(0);
  const [exchange, setExchange] = useState(0);
  const [invoice, setInvoice] = useState(
    {
      invNo:0,
      date: formatDateTime(),
      cashier: user.user?.name,
      uid: user.user?.id,
      customer:'General',
      subtotal: 0,
      vat: 0,
      discount: 0,
      total: 0,
      paidtype:'',
      amountpaid: 0,
      amountdue: 0,
      cart:[cart],
      // "invNo":0,
      // "date": getDate(),
      // "cashier":user.user?.name,
      // "customer":'General Customer',
      // "subtotal": 0,
      // "vat": 0,
      // "discount": 0,
      // "total": 0,
      // "paidtype":'',
      // "amountpaid": 0,
      // "amountdue": 0,
      // "cart":[cart],
    }
  )
  const [vat, setVat] = useState(0);

  //get InvoiceNo and +1
  const getInvNo = async () => {
    try {

      const response = await axios.get(`${apiurl}/invoice.php?mode=getinvno`);
        
           const data = response.data;
            //  console.log(data);
            //  console.log(response);

      // if(data.length>0 && Object.keys(data).length !== 0) {
        if(data.message==="OK") {
          // const data = await response.json();
          // console.log(data[0][0]);
          // setUsers(response.data[0]);
          setInvoice((prev) => ({
            ...prev, 
            invNo: parseInt(data.last_id) +1,
          }));
          return data;
    
      }else {
        console.log(response);
      }
    } catch (error) {
      console.error("Error fetching invoice:", error);

    }
  };

  useEffect(() => {
    getInvNo();
  },[])

  //---



  function subtotal(items) {
    return items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    // return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
  }

  const invoiceSubtotal = subtotal(cart);
  const discountRate = input.discount1>0 ?(input.discount1 * invoiceSubtotal) / 100 : input.discount2>0 ? parseFloat(input.discount2) : 0 ;
  const invoiceTaxes = input.vat>0? (input.vat * (invoiceSubtotal - discountRate)) / 100 : 0;
  const invoiceTotal = (invoiceTaxes + invoiceSubtotal - discountRate);

  const suminvoice = [{
    discount1:  parseFloat(input.discount1),
    discountrate: discountRate,
    vat:       parseFloat(input.vat),
    taxe:     invoiceTaxes,
    subtotal: invoiceSubtotal,
    total:    invoiceTotal,
    cart: cart,
  }] 

    localStorage.setItem("cart", JSON.stringify(suminvoice));

    const handleInput = (e) => {
      // console.log(e.target);
      const { name, value } = e.target;
      if(name==="paidtype") {
        setInput((prev) => ({ ...prev,
          [name]: value,
        }));
        if(value==='ScanQR') {
          setPaidcash(0);
          setExchange(0);
        }
      } else if(name==="discount1") {
        setInput((prev) => ({ ...prev,
          [name]: parseFloat(value),
          discount2: 0,
        }));
      } else if(name==="discount2") {
        setInput((prev) => ({ ...prev,
          [name]: parseFloat(value),
          discount1: 0,
        }));
      } else {
        setInput((prev) => ({ ...prev,
          [name]: parseFloat(value),
        }));
      }
    };
  
  // console.log(input);
  const saveData = async (data) => {
    setSaving(true);
    if(!saveStatus) {
      //save to db
      try {
        const res = await axios({
                  method: 'post',
                  url: `${apiurl}/invoice.php`,
                  headers: {
                      'Accept': 'application/json',
                      // 'Content-type': 'application/x-www-form-urlencoded',
                      // 'Content-type': 'application/json; charset=utf-8',
                      'Content-Type': 'multipart/form-data'
                  },
                  data: JSON.stringify(data) ,
                  // data: data,
              });

              // console.log(res);
              if(res.data?.success) {
                console.log(res.data);
                setSaveStatus(true);
                setSaving(false);

                // console.log("OK")
                // setresMessage("Register Success.");
                // setresMessage("Saved.");
                // setPwd("");
                // setcheckPwd("");
                // setpwdMatch(true);
                // setInput(() => ({
                //   email: "",
                //   name: "",
                // }));

                return true;
              } else {
                setSaving(false);
                return false;
              }

      } catch (error) {
        console.error("Error fetching invoice:", error);
        // setresMessage("Error!!!");
        setSaving(false);
        return false;
      }
    }
  }

  const handlePrint = (e) => {
    e.preventDefault();

    const data = { 
        ...invoice, 
        mode: 'add',
        status:'paided',
        amount:0,
        paidtype: input.paidtype,
        subtotal: invoiceSubtotal,
        vat: invoiceTaxes,
        discount: discountRate,
        total: invoiceTotal,
        cart:cart,
      };

      // console.log(data);
      if(saveData(data)) {
        // print invoice
        window.print();
        handleNext();
        
      }
    

      //-----

    // const bodyElement = document.getElementsByTagName('body')[0];

    // bodyElement.classList.add('printing');
    // window.print();
    // bodyElement.classList.remove('printing');


    
  };

  const handlePaidCash = (e) => {
    const value = e.target.value;
    setPaidcash(value);
    setExchange(value - (invoiceTaxes + invoiceSubtotal - discountRate));
  }

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  
  const handleNext = () => {
    dispatch({
      type: 'empty',
      });

      navigate("/pos/products");
  }
  // console.log(input)
  // console.log(invoice);

  return (
    <div className="absolute w-full h-screen top-0 left-0 z-50  flex flex-col p-0 bg-white ">

      <div id="print" className=" flex flex-col justify-center text-xs bg-white text-black">
        <div className="flex flex-col items-center justify-center mt-1 text-lg font-bold">
          {/* <img src="/logo-720b.png" alt="Online Market" className="w-48" /> */}
          <p>บะหมี่3เอ็น.</p>
          <p className="text-xs">โทร: 089-8328577 , Line ID: บะหมี่3เอ็น.</p>
        </div>
        <div className="flex justify-center text-sm font-bold ">
            <span>Invoice</span>
        </div>
        <div className="flex justify-between px-2">
            <div>
              <span className="font-bold">Date:</span>
              {/* <span className="ml-4">{(new Date()).toISOString().split('T')[0]}</span> */}
              <span className="ml-4">{invoice.date}</span>
            </div>
            <div>
              <span className="font-bold">Invoice:</span>
              <span className="ml-4">#{invoice.invNo}</span>
            </div>
        </div>
        <div className="flex justify-between px-2">
            <div>
              <span className="font-bold">Customer:</span>
              <span className="ml-4">General</span>
            </div>
            <div>
              <span className="font-bold">Cashier:</span>
              <span className="ml-4">{user.user?.name}</span>
            </div>
        </div>

        <div className="flex flex-col  p-2 justify-center">
          <table className="w-full table-auto ">
            <caption className="caption-bottom items-center py-4 text-sm justify-center font-bold">
                  *** ขอบคุณที่ใช้บริการ ***
            </caption>  
          <thead>
              <tr className="border border-slate-300 p-2">
                <th>Item</th>
                <th className="">Qty</th>
                <th className="text-right">Unit/Price</th>
                <th className="text-right pr-2">Total</th>
              </tr>
            </thead>
            <tbody>
            {cart?.map((product,item) => (
              <tr key={item} >
                <td className="pl-2">{`${item+1}. ${product.name}`}</td>
                <td className="text-center ">{product.quantity}</td>
                <td className="text-right pr-2 ">{product.price}฿</td>
                <td className="text-right pr-2 "> {product.price*product.quantity}฿</td>
              </tr>
            ))}
            <tr key="Subtotal" className="border-t-2 ">
              <td rowSpan="4" className="" >
                <div className="flex flex-col sm:flex-row justify-center">
                  <img src="/njqrpay2.jpeg" alt="NJQRPay" className="print:hidden w-full max-w-24 overflow-hidden" />
                  <img src="/qrnoodles.png" alt="Noodles3N" className="hidden print:block w-full max-w-24 overflow-hidden" />
                </div>
              </td>
              <td className=" text-left border-b-2 pl-2 border-slate-300">Subtotal</td>
              <td className=" text-right pr-2  border-b-2 border-slate-300"></td>
              <td className="text-right pr-2  border-b-2 border-slate-300">{invoiceSubtotal}฿</td>
            </tr>
            <tr key="discount" className="">
              {/* <td className=" text-left  border-b-2 border-slate-300"></td> */}
              <td className=" text-left pl-2 border-b-2 border-slate-300">
                Discount
              </td>
              {input.discount1>0 ? (
                  <td className=" text-right pr-2  border-b-2 border-slate-300">{input.discount1}%</td>
                ) :
                (
                  <td className=" text-right pr-2  border-b-2 border-slate-300"></td>
                )
              }
              <td className="text-right pr-2  border-b-2 border-slate-300">{discountRate.toFixed(2)}฿</td>
            </tr>
            <tr key="vat" className="">
              {/* <td></td> */}
              <td className=" text-left  border-b-2 pl-2 border-slate-300">Vat</td>
              {input.vat>0 ? (
                  <td className=" text-right pr-2  border-b-2 border-slate-300">{input.vat}%</td>
                ) :
                (
                  <td className=" text-right pr-2  border-b-2 border-slate-300"></td>
                )
              }
              <td className="text-right pr-2  border-b-2 border-slate-300">{invoiceTaxes.toFixed(2)}฿</td>
            </tr>
            <tr key="total" className=" ">
              {/* <td ></td> */}
              <td className=" text-left border-b-2 pl-2 border-slate-300">Total</td>
              <td className=" text-right pr-2  border-b-2 border-slate-300"></td>
              <td className="text-right pr-2 text-lg font-bold  border-b-2 border-slate-300">{numberWithCommas(invoiceTotal)}</td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>

      <div className="print:hidden flex-row md:flex items-start justify-center mt-4 p-4 rounded-md bg-slate-700">
        <div className="px-4 text-xl ">
          <p>Paid with:</p>
            <form className="flex-row w-32">
            <input 
              type="radio" 
              id="cash" 
              name="paidtype" 
              value="Cash"  
              // onChange={(e) => setInvoice({ ...invoice, paidtype: e.target.value})} 
              onChange={handleInput}
            />
            <label htmlFor="cash" className="px-2">Cash</label><br />
            <input 
              type="radio" 
              id="scanqr" 
              name="paidtype" 
              value="ScanQR" 
              // onChange={(e) => setInvoice({ ...invoice, paidtype: e.target.value})} 
              onChange={handleInput}
            />
            <label htmlFor="scanqr" className="px-2">Scan QR</label><br />
            </form> 
        </div>
        <div className="block lg:inline-block  space-y-2 ">
        
          {/* <div className=" "> */}
            <label
              className="text-sm font-bold md:text-base"
              htmlFor="paidcash"
            >
              Cash Receive:
            </label>
            <div className="flex items-center p-2 gap-x-2">
              <span className="rounded-l-md bg-gray-200 py-1 px-4 font-bold text-gray-500 shadow-sm">
                Cash :
              </span>
              <input
                className="w-32 rounded-r-md px-2 text-2xl text-black bg-white shadow-sm"
                type="number"
                name="paidcash"
                id="paidcash"
                min="0"
                step="0.25"
                placeholder="0.0"
                value={paidcash}
                onChange={handlePaidCash}
                onFocus={(e) => e.target.select()}
              />
            </div>
            <div className="flex items-center p-2 gap-x-2">
              <span className="rounded-l-md bg-gray-200 py-1 px-2 font-bold text-gray-500 shadow-sm">
                Change: 
              </span>
              <input
                className={classNames(
                  exchange<0 ?"text-red-600" : "text-green-500","w-32 rounded-r-md px-2 text-2xl text-black bg-slate-300 shadow-sm")}
                type="number"
                name="exchange"
                id="exchange"
                min="0"
                step="0.25"
                placeholder="0.0"
                disabled
                value={exchange}
                // onChange={(event) => setExchange(event.target.value)}
              />
            </div>
          {/* </div> */}
        </div>  
        <div className="flex-row lg:flex items-center">
          <div className="inline-block  space-y-2 ">
              <label
                className="text-sm font-bold md:text-base"
                htmlFor="discount1"
              >
                Discount rate:
              </label>
              <div className="flex items-center p-2 gap-x-2">
                <input
                  className="w-32 rounded-l-md px-2 text-2xl text-black bg-white shadow-sm"
                  type="number"
                  name="discount1"
                  id="discount1"
                  min="0"
                  step="0.01"
                  placeholder="0.0"
                  value={input.discount1}
                  // onChange={(event) => setDiscount1(event.target.value)}
                  onChange={handleInput}
                  onFocus={(e) => e.target.select()}
                />
                <span className="rounded-r-md bg-gray-200 py-1 px-4 text-gray-500 shadow-sm">
                  %
                </span>
              </div>
              <div className="flex items-center p-2 gap-x-2">
                <input
                  className="w-32 rounded-l-md px-2 text-2xl text-black bg-white shadow-sm"
                  type="number"
                  name="discount2"
                  id="discount2"
                  min="0"
                  step="1.0"
                  placeholder="0.0"
                  value={input.discount2}
                  // onChange={(event) => setDiscount2(event.target.value)}
                  onChange={handleInput}
                  onFocus={(e) => e.target.select()}
                />
                <span className="rounded-r-md bg-gray-200 py-1 px-4 text-gray-500 shadow-sm">
                  ฿
                </span>
              </div>
          </div>  
          <div className="inline-block space-y-0 lg:ml-8 ">
            <div className="space-y-0 ">
                <label
                  className="text-sm font-bold md:text-base"
                  htmlFor="vat"
                >
                  Vat rate:
                </label>
                <div className="flex items-center py-4 p-2 gap-x-2">
                  <input
                    className="w-32 rounded-l-md text-black px-2 text-2xl bg-white shadow-sm"
                    type="number"
                    name="vat"
                    id="vat"
                    min="0"
                    step="0.01"
                    placeholder="0.0"
                    value={input.vat}
                    // onChange={(event) => setVat(event.target.value)}
                    onChange={handleInput}
                    onFocus={(e) => e.target.select()}
                  />
                  <span className="rounded-r-md bg-gray-200 py-1 px-4 text-gray-500 shadow-sm">
                    %
                  </span>
                </div>
              </div>
              
          </div> 
        </div>
      </div>     


      <div className="print:hidden mt-4 md:mt-8 flex items-center justify-around gap-x-6 border-t-2 py-2">
        <div>
          <Link 
              to="/pos/products" 
              // disabled={user.user.isAdmin==1? false : true}
              className="inline-block rounded-md bg-green-700  px-3 py-2 text-sm font-normal text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              // onClick={handleAddnew}
              >
              Back to Shopping...
          </Link>
        </div>
        <div>
          <button 
              type="button" 
              // disabled={user.user.isAdmin==1? false : true}
              className="inline-block rounded-md bg-blue-800  px-3 py-2 text-sm font-normal text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              onClick={handleNext}
              >
              Next Shopping...
          </button>
        </div>
        <div className="flex gap-4">
          <button
            type="submit"
            className={classNames(
              input.paidtype!==""&&invoiceSubtotal>0 ? "bg-cyan-700 hover:bg-cyan-500" : "bg-slate-500" ,"rounded-md px-3 py-2 text-sm font-normal text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600")} 
            // onClick={() => navigate("/invoice")}
            // onClick={() => printDiv('print')}
            disabled={input.paidtype!==""&&invoiceSubtotal>0? false : true}
            onClick={(e) => handlePrint(e)}
          >
            Save & Print.
          </button>
        </div>
      </div>
    </div>

  );
}
